import React from 'react';

const Edit = ({ width, height, color }) => (
  <svg width={width || '18'} height={height || '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.375 14.625H4.2L12.5062 6.31873L11.6812 5.49373L3.375 13.8V14.625ZM14.8875 5.51248L12.4875 3.11248L13.275 2.32498C13.4875 2.11248 13.75 2.00623 14.0625 2.00623C14.375 2.00623 14.6375 2.11248 14.85 2.32498L15.675 3.14998C15.8875 3.36248 15.9938 3.62498 15.9938 3.93748C15.9938 4.24998 15.8875 4.51248 15.675 4.72498L14.8875 5.51248ZM14.1 6.29998L4.65 15.75H2.25V13.35L11.7 3.89998L14.1 6.29998ZM12.0938 5.90623L11.6812 5.49373L12.5062 6.31873L12.0938 5.90623Z" fill={color || '#F1F1F1'} />
  </svg>

);

export default Edit;